import { graphql } from '~/__gql__/index';

export const mutationRequestInternalDocumentManagementUpsell = graphql(/* GraphQL */ `
  mutation RequestInternalDocumentManagementUpsell {
    requestInternalDocumentManagementUpsell
  }
`);
